import links from '../links'


const getProductCategoryLinkByPathname = (props: { pathname: string }): string | void => {
  const { pathname } = props

  if (/\/hand-cream/.test(pathname) && typeof links.handCreams === 'string') {
    return links.handCreams
  }
  // TODO remove lip-balm - looks like we don't use it
  if (/\/(lip-balm|body-lip)/.test(pathname) && typeof links.bodyLip === 'string') {
    return links.bodyLip
  }
  if (/\/shower-gel/.test(pathname)) {
    return '/shower-gels' // TODO we don't have such page
  }
  if (/\/candle/.test(pathname) && typeof links.candles === 'string') {
    return links.candles
  }

  /*

   /makeup/*eye*
   /makeup/*lip*
   /makeup/*face*
   /makeup/*cheek*
   /makeup/*tools*
   /makeup-eye*
   /makeup-lip*
   /makeup-face*
   /makeup-cheek*
   /makeup-tools*

   */
  if (/\/makeup/.test(pathname)) {
    if (/\/palette/.test(pathname) && typeof links.makeupPalettes === 'string') {
      return links.makeupPalettes
    }
    if (/\/eye/.test(pathname) && typeof links.makeupEye === 'string') {
      return links.makeupEye
    }
    if (/\/lip/.test(pathname) && typeof links.makeupLip === 'string') {
      return links.makeupLip
    }
    if (/\/face/.test(pathname) && typeof links.makeupFace === 'string') {
      return links.makeupFace
    }
    if (/\/cheek/.test(pathname) && typeof links.makeupCheek === 'string') {
      return links.makeupCheek
    }
    if (/\/tools/.test(pathname) && typeof links.makeupTools === 'string') {
      return links.makeupTools
    }
  }

  /*

   /extra/
   /extras/

   */
  if (
    /\/extras?/.test(pathname)
    && typeof links.subscription !== 'string'
    && typeof links.subscription.extras === 'string'
  ) {
    return links.subscription.extras
  }
}


export default getProductCategoryLinkByPathname
